module.exports = __webpack_public_path__ + "img/ff2.0c59fc1e.jpg";